import { createApp } from 'vue';

import { initSentry } from '@/javascripts/utils/sentry_helper';

import { initLiff, isLiffApp, LoginRequiredError } from '@/javascripts/utils/liff_helper';

// Vueの初期化
import SlideForm from '@/javascripts/components/slide_form2023.vue';

async function initialize() {
    // Vueを先にマウントする（旧フォームと同様の挙動）
    // マウント前に initLiff() を呼ぶとリダイレクトとVueマウントが競合するため
    const app = createApp(SlideForm);
    initSentry(app);
    app.mount('#app');

    // /liff/inquiryではマウント後にLIFF初期化を行う
    if (window.location.pathname === '/liff/inquiry' && isLiffApp()) {
        try {
            await initLiff();
        } catch (error) {
            // ログインリダイレクト中はそのまま遷移させる
            if (error instanceof LoginRequiredError) {
                return;
            }
            // その他のエラーは握りつぶす
        }
    }
}

initialize();
